import {
  getBaseUrl,
  ADMIN_ENDPOINT,
  BILLING_CONFIG_ENDPOINT,
} from '../../constant'
import { createFetcher } from '../../Fetcher/Fetcher'

/**
 * For BillingConfig
 * @Applications
 */
export class BillingConfig {
  static getInstance() {
    if (!this.instance) {
      this.instance = new BillingConfig(
        BILLING_CONFIG_ENDPOINT,
        ADMIN_ENDPOINT,
        createFetcher()
      )
    }
    return this.instance
  }

  constructor(endpoint, adminEndPoint, fetcherObj) {
    this.endpoint = endpoint
    this.adminEndPoint = adminEndPoint
    this.fetcher = fetcherObj
  }

  /**
   * this function is to get all applications
   * @function getBillingConfig
   */
  async getBillingConfig() {
    const url = `${getBaseUrl()}${this.adminEndPoint}${this.endpoint}`

    const response = await this.fetcher.getData(url)
    return response?.data?.data
  }
}

export const createBillingConfigs = () => BillingConfig.getInstance()
